import React from 'react'
import Main from "./container/Main"
import "./App.css"
const App = () => {
  return (
    <Main />
  )
}

export default App